import React, { useEffect, useRef } from "react";

const Expire = ({ callback, delay, visible, children }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      callback();
      timerRef.current = null; 
    }, delay);

    return () => clearTimeout(timerRef.current);
  }, [delay]);

  return visible ? <div>{children}</div> : <span />;
};

const DownloadNotification = ({ downloading, onCloseClick, translations }) => {

  return downloading ? (
    <Expire delay={60000} visible={downloading} callback={onCloseClick}>
      <div className="alert alert-warning alert-dismissible" data-testid="alert-warning">
        <i className="fa fa-spinner fa-spin" />
        {" "}
        <span className="download_notification__message">
          {translations.download_notification}
        </span>
        <button 
          type="button" 
          className="btn-close" 
          data-bs-dismiss="alert"
          aria-label="Close" 
          onClick={onCloseClick}
        >
        </button>
      </div>
    </Expire>
  ) : null;
}

export default DownloadNotification;